import {Component} from '@angular/core';
import {
  AlertController, IonicPage, LoadingController, ModalController, NavController, NavParams,
  Platform, ToastController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {SocialSharing} from "@ionic-native/social-sharing";
import {Storage} from '@ionic/storage';

@Component({
  selector: 'page-school-enquiry',
  templateUrl: 'school-enquiry.html',
})
export class SchoolEnquiryPage {

  Standard = 'All';
  StandardData = {};

  AcademicYear: any;
  AcademicYearData: any;

  EnquiryData = [];
  EnquiryData1 = [];
  datanotfound: any;
  DataSearch: any;

  StdCount_0: any;
  StdCount_Null:any;
  StdCount_1: any;
  StdCount_2: any;
  StdCount_3: any;
  StdCount_4: any;
  StdCount_5: any;
  StdCount_6: any;
  StdCount_7: any;

  School = 'GEIS';
  SchoolData = {};
  FUserId:null;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public platform: Platform,
              private socialSharing: SocialSharing,
              public service: ServiceProvider,
              public alertCtrl: AlertController,
              public loadingCtrl: LoadingController,
              public toastCtrl:ToastController,
              public storage: Storage) {
    this.platform.ready().then(() => {

      Promise.all([this.storage.get('LoginData')]).then(values => {
        this.FUserId = values[0]['FUserId'];
      });

      this.SchoolData = {
        "GWW": 2,
        "GWE": 3,
        "GEIS": 1
      };

      this.loadAcademicYearData(this.SchoolData[this.School]);

      this.StandardData = {
        "All": 0,
        "Null":80,
        "1": 1,
        "2": 2,
        "3": 3,
        "4": 4,
        "5": 5,
        "6": 6,
        "7": 7
      }
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SchoolEnquiryPage');
  }

  active_School_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.active_tab(this.Standard);
    this.loadAcademicYearData(this.SchoolData[this.School]);
  }

  active_tab(tab) {
    console.log(tab);
    this.Standard = tab;
    this.DataSearch = null;
    this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear);
    this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
  }

  loadAcademicYearData(SchoolId) {
    this.service.httpcall('web_service/get_academic_year_by_school_id?FSchoolId=' + SchoolId).subscribe(data => {
      console.log(data);
      this.AcademicYearData = data;
      let AcademicYearDataCount = this.AcademicYearData.length;
      console.log(AcademicYearDataCount);
      this.AcademicYear = this.AcademicYearData[0]['Id'];
      console.log("Id", this.AcademicYear);
      this.getStudents();
    })
  }

  getStudents() {
    this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
    this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear);
  }

  loadvalues(SchoolId, Standard, FAcademicYearId) {
    this.datanotfound = null;
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    setTimeout(() => {
      loading.dismiss();
      loading = undefined;
    }, 3000);

    this.EnquiryData=[];
    this.EnquiryData1=[];

    this.service.httpcall('app_web_service/get_Enquiry_by_school_erp?FSchoolId=' + SchoolId + '&FAcademicYearId=' + FAcademicYearId + '&Standard=' + Standard + '&FUserId=' + this.FUserId).subscribe(data => {
      console.log(data);
      if (loading)
        loading.dismiss();
      loading = undefined;
      if (data['response'] == "success") {
        this.EnquiryData1=data['data'];
        this.EnquiryData = this.EnquiryData1;
      } else {
        this.datanotfound = data['error_description'];
      }
    })
  }

  loadCountvalues(School, FAcademicYearId) {
    this.service.httpcall('app_web_service/get_Enquiry_by_school_erp_count?FSchoolId=' + School + '&FAcademicYearId=' + FAcademicYearId).subscribe(data => {
      console.log(data);
      this.StdCount_0 = data[0]['StdCount_0'];
      this.StdCount_Null = data[8]['StdCount_80'];
      this.StdCount_1 = data[1]['StdCount_1'];
      this.StdCount_2 = data[2]['StdCount_2'];
      this.StdCount_3 = data[3]['StdCount_3'];
      this.StdCount_4 = data[4]['StdCount_4'];
      this.StdCount_5 = data[5]['StdCount_5'];
      this.StdCount_6 = data[6]['StdCount_6'];
      this.StdCount_7 = data[7]['StdCount_7'];
    })
  }

  send_msg(item,BtnMsg) {

    console.log("Message -> ",BtnMsg);
    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Whatsapp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);
            this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, BtnMsg, null, null);
          }
        }
      ]
    });

    if(item.MotherContact){
      myAlert.addInput({
        type: 'radio',
        label: item.MotherContact,
        value: item.MotherContact
      })
    }
    if(item.Mobile){
      myAlert.addInput({
        type: 'radio',
        label: item.Mobile,
        value: item.Mobile
      })
    }
    myAlert.present();


  }

/*  send_msg(item,btn) {

    let myAlert = this.alertCtrl.create({
      title: 'Enquiry Contacts',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'WhatsApp',
          handler: (data) => {
            console.log('Message clicked');
            console.log(data);

            let loading = this.loadingCtrl.create({
              content: 'Loading'
            });
            loading.present();
            setTimeout(() => {
              loading.dismiss();
              loading = undefined;
            }, 3000);

            this.service.httpcall('app_web_service/get_erp_enquiry_predefined_Msg_by_btn?BtnNo=' + btn ).subscribe(msgdata => {
              console.log(msgdata);
              if (loading)
                loading.dismiss();
              loading = undefined;
              if (msgdata['response'] == "success") {
                console.log("Message -> ",msgdata['data'].Message);

                this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, msgdata['data'].Message, null, null);
              } else {
                this.presentToast(msgdata['error_description']);
              }
            })

          }
        }
      ]
    });

    if(item.MotherContact){
      myAlert.addInput({
        type: 'radio',
        label: item.MotherContact,
        value: item.MotherContact
      })
    }
    if(item.Mobile){
      myAlert.addInput({
        type: 'radio',
        label: item.Mobile,
        value: item.Mobile
      })
    }
    myAlert.present();


  }
 */

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);
    this.loadCountvalues(this.SchoolData[this.School], this.AcademicYear);
    this.loadvalues(this.SchoolData[this.School], this.StandardData[this.Standard], this.AcademicYear);
    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/school-enquiry/school-enquiry.ts